module.exports = __webpack_public_path__ + "media/assets/images/blog/elettronic_board-a4d8b2fa88e35d50611cf05e372fff1e.jpeg";